<ion-button
	(click)="presentPopover($event)"
	(keydown.enter)="presentPopover($event)"
	class="bsg-burger-menu-button"
	aria-label="Open menu"
	aria-haspopup="true"
	aria-expanded="false"
	tabindex="0"
>
	<ion-icon size="large" slot="icon-only" src="../../../assets/dean_and_david/burger_menu.svg" aria-hidden="true"></ion-icon>
</ion-button>
